import { SoundEffect } from "../music/SoundEffect";

export const audio_engine = {
  music_volume: 0.5 as number,
  effect_volume: 0.5 as number,
  sound_effects: [] as SoundEffect[],
};
